import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useContactCardSection } from "@/contexts/contact";
import { Rating } from "@gemini/ui";
export const ContactCardRating = ({ marginBottom = "spacing.16", }) => {
    const contactCardSection = useContactCardSection();
    return (_jsx(_Fragment, { children: (contactCardSection === null || contactCardSection === void 0 ? void 0 : contactCardSection.rating) && (_jsx(Rating, { marginBottom: marginBottom, rating: contactCardSection.rating, size: "16" })) }));
};
